import { render, staticRenderFns } from "./TrabajoAdicional.vue?vue&type=template&id=b0da5c3c"
import script from "./TrabajoAdicional.vue?vue&type=script&lang=js"
export * from "./TrabajoAdicional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports